import React from 'react';

import { Message } from './styles';

const NoResultsMessage = () => (
  <Message>No results found</Message>
);

export default NoResultsMessage;
